// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__c8i8-","inner":"Page_inner__1Q73S","discord":"Page_discord__9TLzM","BackToTop":"Page_BackToTop__G8XhU","fadein":"Page_fadein__1B66u"};